/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate } from "react-router";
import {
  ControlledInput,
  PrimaryButton,
  SecondaryButton,
} from "../../components";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { useLeadingSources } from "../../store/useLeadingSources";

type Inputs = {
  name: string;
};

function AddLeadingSourceScreen() {
  /** Hooks */
  const { addLeadingSource, addedLeadingSource, clearAddedLeadingSource } =
    useLeadingSources();
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  /** Effects */
  useEffect(() => {
    if (addedLeadingSource) {
      clearAddedLeadingSource();
      navigate(-1);
    }
  }, [addedLeadingSource]);

  /** Callbacks */
  const goBack = () => navigate(-1);

  const onSubmit = async (data: Inputs) => {
    addLeadingSource(data);
  };

  return (
    <div>
      <div className="flex flex-row items-center mb-6">
        <h1 className="font-satoshi text-2xl font-bold text-dark">
          Add new Leading Source
        </h1>
      </div>
      <div className="flex flex-col sm:flex-row">
        <div className="w-full sm:w-1/2 bg-white  border-gray-border drop-shadow-none rounded-xl mb-1 sm:mb-0">
          <div className="w-full border-b border-gray-border px-[28px] py-[15px]">
            <p className="font-satoshi font-medium text-base text-dark">
              New Leading Source
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="w-full px-7 py-7">
            <ControlledInput
              control={control}
              error={Boolean(errors?.name)}
              label="Name"
              placeholder="Leading Source name"
              name="name"
              rules={{ required: true }}
            />
            <div className="flex flex-row items-center justify-end">
              <SecondaryButton
                type="button"
                onClick={goBack}
                label="Cancel"
                className="mr-3 h-8 px-4 py-0 bg-white border border-droppie-oranje text-droppie-oranje hover:bg-droppie-oranje/5 flex items-center justify-center"
                labelClassName="text-droppie-oranje"
              />
              <PrimaryButton
                type="submit"
                className="ml-4 !bg-droppie-oranje !border-droppie-oranje active:!bg-droppie-oranje-dark"
                size="sm"
                label="Save"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default withProtectedRoute(AddLeadingSourceScreen);
